/* Matrikar - Frequently Purchased Together - ajout par item autonome (DEV up sell 10082026).
   Definit window.mkAddSingleItem : ajoute UN variant au panier AVEC le fitment vehicule
   (memes proprietes de ligne que l'ATC principal), en relisant localStorage matrikar_vehicle.
   Reutilise les bus globaux window.mkEmitCartChanged / window.openMatrikarCart quand presents. */
(function () {
  if (window.mkAddSingleItem) return;
  function toast(msg, isErr) {
    var t = document.getElementById('bundle-toast');
    if (!t) {
      t = document.createElement('div');
      t.id = 'bundle-toast';
      Object.assign(t.style, {
        position: 'fixed', bottom: '28px', left: '50%', transform: 'translateX(-50%)',
        background: isErr ? '#D71A23' : '#030213', color: '#fff', fontSize: '14px',
        fontWeight: '600', padding: '12px 24px', borderRadius: '4px', opacity: '0',
        transition: 'opacity .3s', zIndex: '99999', pointerEvents: 'none', fontFamily: 'inherit'
      });
      document.body.appendChild(t);
    }
    t.textContent = msg;
    t.style.background = isErr ? '#D71A23' : '#030213';
    t.style.opacity = '1';
    clearTimeout(t._x);
    t._x = setTimeout(function () { t.style.opacity = '0'; }, 2600);
  }
  window.mkAddSingleItem = async function (variantId, opts) {
    opts = opts || {};
    var raw = null, v = null;
    try { raw = localStorage.getItem('matrikar_vehicle'); } catch (e) {}
    try { v = raw ? JSON.parse(raw) : null; } catch (e) {}
    if (!(v && v.make && v.year && v.model)) {
      toast((window.MK_I18N && window.MK_I18N.cu_confirm_vehicle_first) || 'Please select & confirm your vehicle first', true);
      return false;
    }
    var vid = parseInt(variantId, 10);
    if (!vid) return false;
    var payload = new FormData();
    payload.append('id', vid);
    payload.append('quantity', 1);
    var seats = v.seats ? (v.seats + ' seats') : '';
    var props = {
      'Vehicle': [v.make, v.model, v.sub].filter(Boolean).join(' '),
      'Vehicle Year': v.year || '',
      'Trim': v.sub || '',
      'Seats': seats,
      'Drive Side': v.drive || '',
      'Fuel Type': v.fuel || ''
    };
    Object.keys(props).forEach(function (k) { if (props[k]) payload.append('properties[' + k + ']', props[k]); });
    try {
      var r = await fetch(((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: payload });
      if (!r.ok) throw new Error('add failed');
      try {
        var cr = await fetch(((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart.js');
        var cart = await cr.json();
        document.querySelectorAll('.cart-count, .cart__count, .cart-item-count, [data-cart-count], .header__cart-count, .cart-count-bubble')
          .forEach(function (el) { if (el) el.textContent = cart.item_count; });
        if (typeof window.mkEmitCartChanged === 'function') window.mkEmitCartChanged(cart, 'fpt-add');
      } catch (e) {}
      toast((window.MK_I18N && window.MK_I18N.cu_added_to_cart) || 'Added to cart', false);
      // Voulu par Ilyes : ajoute SANS ouvrir le panier / rediriger. On ne touche pas au drawer.
      return true;
    } catch (e) {
      toast('Something went wrong. Please try again.', true);
      return false;
    }
  };
})();
